"use client";

import { MoonIcon } from "@/shared/icons/MoonIcon";
import { useTheme } from "./hooks/useTheme";
import { SunIcon } from "@/shared/icons/SunIcon";

import styles from "./ThemeToggle.module.css";
import clsx from "clsx";

export function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();

  const handleChange = () => {
    const newTheme = resolvedTheme === "dark" ? "light" : "dark";
    setTheme(newTheme);
  };

  return (
    <button
      onClick={handleChange}
      className={clsx(styles.button, styles[resolvedTheme])}
      aria-label={`Переключить на ${resolvedTheme === "dark" ? "светлую тему" : "темную тему"}`}
    >
      {resolvedTheme === "dark" && <SunIcon size="16" />}
      {resolvedTheme === "light" && <MoonIcon size="16" />}
    </button>
  );
}
